import React from "react";
import PageTitle from "../../../global/PageTitle";
import MyCard from "../../../tools/MyCard";
import MyCard2 from "../../../tools/MyCard2";
import MyCard3 from "../../../tools/MyCard3";
import MyCard5 from "../../../tools/MyCard5";
import MyCard6 from "../../../tools/MyCard6";
import { Upload } from "lucide-react";

export default function FirebaseConfig() {
  return (
    <div className="space-y-2">
      <PageTitle
        title="Firebase Configure"
        subtitle="Configure Firebase Cloud Messaging for push notifications"
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <MyCard6
          color="orange"
          className="md:col-span-1"
          title="Firebase Project"
          subtitle="Your Firebase project identifier"
        >
          <div className="p-4">
            {/*  Project id */}
            <label className="text-xs font-sans font-medium  text-slate-900 dark:text-slate-200 tracking-wide">
              Project ID
            </label>

            {/* Input */}
            <input
              type="text"
              name="projrctId"
              // value="mangocash.moon"

              //   onChange={(e) => setValue(e.target.value)}
              placeholder="my-firebase-project-id"
              className="w-full  px-2 py-2 rounded-md 
            mt-2 text-slate-900 dark:text-white text-xs font-semibold placeholder:font-normal placeholder-slate-500 
            dark:placeholder:text-slate-400
             readOnly
            focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all 
            border-[2px] border-slate-200 dark:border-slate-300/30"
            />
            <span className="text-[10px] text-slate-700/60 dark:text-slate-400/70">
              Find your Project ID in Firebase Console → Project Settings
            </span>
          </div>
        </MyCard6>
        <MyCard6
          icon={Upload}
          color="blue"
          title="Service Worker File"
          subtitle="Upload service-worker.json configuration"
          className="md:col-span-1"
        >
          <div
            className="  p-5
                     bg-white dark:bg-slate-600/30 
                     rounded-xl
                    relative"
              >
            <div
              className=" py-8 flex flex-col 
                      justify-center items-center 
                      rounded-lg 
                      cursor-pointer hover:bg-gray-200/40
                      dark:hover:bg-gray-400/20
                      border-dotted border-2 border-gray-300 hover:border-blue-500 hover:dark:border-blue-400"
            >
              <Upload className="w-14 h-14 p-3 rounded-full bg-gray-400/20 dark:bg-gray-500 text-slate-400 dark:text-slate-300" />
              <span className="text-xs text-slate-800 dark:text-slate-100 font-semibold mt-3">
                Drag & drop your JSON file here
              </span>
              <span className="text-[11px] mt-1 text-slate-500 dark:text-slate-100 font-normal ">
                service.json file
              </span>

              {/* Hidden file input */}
              <input
                type="file"
                accept=".json"
                //   ref={fileInputRef}
                // onChange={handleFileChange}
                className="absolute inset-0 w-full h-full opacity-0  bg-amber-500 cursor-pointer"
              />
            </div>
          </div>
        </MyCard6>
            <MyCard5 className="grid md:col-span-2 flex  " title="No Configuration Found" subtitle="Upload a service-worker.json file and provide your Firebase Project ID to enable push notifications"/>

      </div>
    </div>
  );
}
